<ng-template *ngIf="email; then emailTrue else emailFalse"></ng-template>
<ng-template #emailTrue>
  <a class="lisitng-email-label" href="mailto:{{emailEncoded}}" title="{{email}}" target="_blank">
    {{(email) ? (email.length > 28)  ? email.slice(0, 28) + '...' : email.slice(0, 28) : ''}}
  </a>
</ng-template>
<ng-template #emailFalse>
  <div class="opacity-50 fs-075r">No E-Mail</div>
</ng-template>